<div
	[class]="rightAligned() ? 'flex justify-end' : ''"
	(mouseenter)="onHover(true)"
	(mouseleave)="onHover(false)"
>
	@switch (renderAs()) {
		@case ('anchor-router') {
			<a
				id="baseUiButton"
				[class]="styles()"
				[routerLink]="disabled() ? null : route()"
				[queryParams]="queryParams()"
				(click)="clicked($event)"
				[style]="colorStyles()"
				[attr.target]="target()"
				[attr.tabindex]="disabled() ? -1 : tabindex()"
				[attr.aria-label]="ariaLabel()"
				[attr.aria-disabled]="disabled() || null"
				[uiTooltip]="tooltip()"
				[tooltipPosition]="tooltipPosition()"
				#focusable
			>
				<ng-container [ngTemplateOutlet]="content"></ng-container>
			</a>
		}
		@case ('anchor-href') {
			<a
				id="baseUiButton"
				[class]="styles()"
				[attr.href]="disabled() ? null : href()"
				(click)="clicked($event)"
				[style]="colorStyles()"
				[attr.target]="target()"
				[attr.rel]="rel()"
				[attr.tabindex]="disabled() ? -1 : tabindex()"
				[attr.aria-label]="ariaLabel()"
				[attr.aria-disabled]="disabled() || null"
				[uiTooltip]="tooltip()"
				[tooltipPosition]="tooltipPosition()"
				#focusable
			>
				<ng-container [ngTemplateOutlet]="content"></ng-container>
			</a>
		}
		@default {
			<button
				id="baseUiButton"
				[class]="styles()"
				type="button"
				(click)="clicked($event)"
				(mousedown)="onMouseDown($event)"
				[style]="colorStyles()"
				[attr.tabindex]="disabled() ? -1 : tabindex()"
				[attr.aria-label]="ariaLabel()"
				[attr.aria-disabled]="disabled() || null"
				[uiTooltip]="tooltip()"
				[tooltipPosition]="tooltipPosition()"
				#focusable
			>
				<ng-container [ngTemplateOutlet]="content"></ng-container>
			</button>
		}
	}
</div>

<ng-template #content>
	@if (iconOnLeft()) {
		<ng-container [ngTemplateOutlet]="iconContent"></ng-container>
	}

	@if (!displayLoadingText()) {
		<span
			class="truncate min-w-0"
			[class.opacity-0]="showSpinner()"
			[class.hidden]="noTextOnMobile()"
			[class.ml-2]="text() && iconOnLeft()"
			[class.mr-2]="text() && iconOnRight()"
			>{{ text() }}</span
		>
	}

	@if (iconOnRight()) {
		<ng-container [ngTemplateOutlet]="iconContent"></ng-container>
	}

	@if (showSpinner()) {
		<div class="flex items-center gap-2 leading-none">
			<ui-spinner
				id="uiButtonSpinner"
				size="s"
				[inverted]="spinnerConfig().inverted"
				[color]="spinnerConfig().color"
				[inlineCompact]="displayLoadingText()"
			></ui-spinner>
			@if (loadingText()) {
				<span>{{ loadingText() }}</span>
			}
		</div>
	}
</ng-template>

<ng-template #iconContent>
	<div [class.opacity-0]="showSpinner()" [class.-mx-2]="noTextOnMobile()">
		<ui-icon [icon]="icon()" [size]="iconSize()"></ui-icon>
	</div>
</ng-template>
